export const msalConfig = {
  auth: {
    // 'Application (client) ID' of app registration in Azure portal - this value is a GUID
    clientId: '7db8ea87-27a7-42f5-a228-d3c82041ebb1',
    // Full directory URL, in the form of https://login.microsoftonline.com/<tenant-id>
    authority: 'https://login.microsoftonline.com/8c6c4f2c-3b97-427e-ab0f-1b982441831a',
    // Full redirect URL, in form of http://localhost:3000
    redirectUri: 'https://local.hubspotqa.com/signup-hubspot'
  },
  cache: {
    cacheLocation: 'sessionStorage',
    // This configures where your cache will be stored
    storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge

  }
};